import { useEffect, useState } from 'react';
import ARQRcode from './ARQRcode';
import Button from '../../components/Button';
import CartIconWhite from '../../assets/images/cart_icon_white.svg';
import { openFormInCaseOfNewOrgAndFreemiumUser, windowOpen } from '../../helpers/jsHelper';
import {
  AddAddonCart,
  GetAllCartProductList,
  linkSubscriptionProductData,
  removeAllItemsFromCart,
  setClientSubscriptionPlans,
} from '../../api/subscription/subscription';
import {
  LINKED_PRODUCT_DATA,
  OFFER_PRICE_DATA,
  navigateToUpgradePlan,
} from '../../screens/subscriptionComponents/subscriptionHelper';
import { dispatcher, navigate } from '../../helpers/projectHelper';
import {
  ADMIN_SETTINGS,
  PRODUCT_AR_VIEWER_PUBLIC,
  SIGN_IN_ROUTE,
  SIGNUP_ROUTE,
} from '../../constants/routePathConstants';
import { useUserContext } from '../../contexts/UserContext';
import ShareButton from '../../screens/NewProductUI/ShareButton';
import { useCopyToClipboard } from 'react-use';
import { errorToast, successToast } from '../../helpers/toastHelper';
import { useInfoDialogaActions } from '../../hooks/useInfoDialogaActions';
import {
  selectAddonsList,
  selectAvailable3DViewerAR,
  selectHighestPlanOrderId,
  selectUserActivePlanDetails,
  selectUserActivePlanSubscriptionOrderId,
  selectUserPlanList,
} from '../../redux/slicers/subscriptionSlicer';
import { useSelector } from 'react-redux';
import styles from '../../components/InfoDialog/InfoDialogUI.module.scss';
import useCurrentOrganizationInfo from '../../hooks/useCurrentOrganizationInfo';
import { SETTINGS_TAB } from '../../constants/constants';
import { selectPdpProductCountInfo } from '../../redux/slicers/productV2Slicer';
import { isPdpProduct } from '../../screens/NewProductUIV2/ShareButtonV2/helpers';

function ARViewButton({
  isPublicPage,
  productInfo,
  propId,
  propName,
  productUnicodeId,
  orgProductUniqueCodeId,
  refetchDetails,
  loading,
  isPackProduct,
}) {
  const { currentUser, isOldSubscriptionUser, isPremiumUser, isGuestUser, isGuestLogin } =
    useUserContext();
  const { isFreemiumUser, isFreemiumOrSelfServeUser, hideNewPlans } = useCurrentOrganizationInfo();

  const [state, copy] = useCopyToClipboard();

  const { openInfoDialog, closeInfoDialog } = useInfoDialogaActions();

  const activePlan = useSelector(selectUserActivePlanDetails) || isOldSubscriptionUser();
  const available3DViewerCount = useSelector(selectAvailable3DViewerAR);
  // const highestPlanOrder = useSelector(selectHighestPlanOrderId);
  // const activePlanOrder = useSelector(selectUserActivePlanSubscriptionOrderId);

  const getUserPlans = useSelector(selectUserPlanList);
  const isOldPremiumUser = isPremiumUser() && getUserPlans?.length === 0;
  const { results: addonsList } = useSelector(selectAddonsList);

  // const showUpgradeButton = highestPlanOrder > activePlanOrder;

  const [actionMenu, setActionMenu] = useState([]);
  const pdpProductCountInfo = useSelector(selectPdpProductCountInfo);
  const pdpArViewerCount = pdpProductCountInfo?.ar_viewer || 0;

  useEffect(() => {
    setActionMenu([
      {
        id: 1,
        title: 'Disabled',
        icon: null,
        onClick: handleEnabledDisabled,
        type: 'toggle',
        initialValue: false,
      },
      { id: 2, title: 'Copy Link', icon: null, onClick: handleCopy, disabled: true },
      { id: 3, title: 'Embed on website', icon: null, onClick: handleEmbedding, disabled: true },
    ]);
  }, [
    productUnicodeId,
    orgProductUniqueCodeId,
    productInfo?.product_viewer_status,
    pdpArViewerCount,
  ]);

  useEffect(() => {
    setActionMenu((prev) => [
      ...prev
        .map((a) => {
          if (a.id === 1 && !isPackProduct) {
            return {
              ...a,
              title:
                productInfo?.product_viewer_status || pdpArViewerCount ? 'Enabled' : 'Disabled',
              initialValue: productInfo?.product_viewer_status || pdpArViewerCount,
              disabled: pdpArViewerCount ? true : false,
            };
          }
          if (a.id === 1 && isPackProduct) return null;
          return {
            ...a,
            disabled: isPackProduct
              ? false
              : productInfo?.product_viewer_status || pdpArViewerCount
              ? false
              : true,
          };
        })
        .filter(Boolean),
    ]);
  }, [
    productUnicodeId,
    orgProductUniqueCodeId,
    productInfo?.product_viewer_status,
    pdpArViewerCount,
    isPackProduct,
  ]);

  async function doEnableDisable(toggleValue) {
    const formData = new FormData();
    formData.append('type', LINKED_PRODUCT_DATA.PRODUCT_VIEWER);
    formData.append('is_link', toggleValue);
    formData.append('product_id', propId);
    const res = await linkSubscriptionProductData(formData);
    if (res?.status) {
      successToast(res?.message);
    } else {
      toggleValue = false;
    }
    dispatcher(setClientSubscriptionPlans());
    refetchDetails?.();

    const updatedMenu = actionMenu.map((a) => {
      if (a.id === 1) {
        return {
          ...a,
          title: toggleValue ? 'Enabled' : 'Disabled',
          initialValue: toggleValue,
        };
      }
      return {
        ...a,
        disabled: !toggleValue,
      };
    });
    setActionMenu(updatedMenu);
  }

  function openModelWhileDisabling(toggleValue) {
    openInfoDialog({
      title: 'AR Viewer',
      description:
        'Disabling AR viewer will also disable 360° viewer. This will disable the public link or embedded link you used. Are you sure you want to continue?',
      buttonText: 'Yes',
      onButtonClick: () => doEnableDisable(toggleValue),
      cancelButtonText: 'No',
      dialogClassName: styles.viewerModal,
      designV2: true,
      btnContainerClass: 'justify-content-end',
      designV2Props: {
        fillBtnClassName: styles.viewerBtn,
        cancelBtnClassName: styles.cancelBtn,
      },
    });
  }

  function handleEnabledDisabled(item) {
    item.e.stopPropagation();
    let toggleValue = item.value;
    if (toggleValue) doEnableDisable(toggleValue);
    else openModelWhileDisabling(toggleValue);
  }

  function handleCopy() {
    if (!orgProductUniqueCodeId) {
      errorToast('Unable to copy. Please try again later.');
      return;
    }
    const url =
      window.location.origin + PRODUCT_AR_VIEWER_PUBLIC.replace(':id', orgProductUniqueCodeId);
    copy(url);
    successToast('Link Copied');
  }

  function handleEmbedding() {
    if (!orgProductUniqueCodeId) {
      errorToast('Unable to copy. Please try again later.');
      return;
    }
    const embedLink =
      window.location.origin + PRODUCT_AR_VIEWER_PUBLIC.replace(':id', orgProductUniqueCodeId);
    const iframeCode = `<iframe style="border: none;" src="${embedLink}" title="${productInfo?.name}" width="100%" height="300px"></iframe>`;
    copy(iframeCode);
    successToast('Embed Link Copied');
  }

  const buy3DviewerAndAr = async () => {
    await dispatcher(GetAllCartProductList());
    const addonsItem = addonsList?.find(
      ({ basemodeltype }) => basemodeltype === OFFER_PRICE_DATA['3D_Viewer'].baseModelType
    );
    let payload = {
      subscription_price: addonsItem?.id || OFFER_PRICE_DATA['3D_Viewer'].product_id,
      quantity: 1,
    };

    await removeAllItemsFromCart();

    const response = await AddAddonCart(payload, 'add');

    if (response?.status) {
      closeInfoDialog();
      let tab = SETTINGS_TAB.ADD_ONS;
      if (isFreemiumOrSelfServeUser) {
        tab = SETTINGS_TAB.PLANS;
      }

      windowOpen(
        `${ADMIN_SETTINGS}?activeTab=${tab}&checkout=true&is_one_time=false&referrer=${window.location.href}`,
        '_blank'
      );
    }
  };

  const handleShareForUse = () => {
    if (isPdpProduct()) {
      if (!pdpArViewerCount) {
        openFormInCaseOfNewOrgAndFreemiumUser();
        return;
      }
      return;
    }
    if (hideNewPlans || isFreemiumUser) {
      // open enterprise form in case of freemium user whose org is created after 10th Feb 2025
      openFormInCaseOfNewOrgAndFreemiumUser();
      return;
    }
    let title = 'Add item';
    let description = '';
    let buttonText = '';
    let buttonText2 = '';
    let onButtonClick = null;
    let onButtonClick2 = null;
    if (isOldPremiumUser && available3DViewerCount === 0) {
      title = 'Buy add on';
      buttonText = 'Buy';
      description = 'This item will be added on top of your existing subscription (if any).';
      onButtonClick = buy3DviewerAndAr;
    } else if (!activePlan && available3DViewerCount === 0) {
      buttonText = 'View plans';
      description =
        'You currently do not have an active subscription. Please purchase a subscription plan or buy this item separately.';
      onButtonClick = () =>
        navigateToUpgradePlan({ browsePlan: true, newTab: true, referrer: window.location.href });
      buttonText2 = 'Buy item';
      onButtonClick2 = buy3DviewerAndAr;
    } else if (available3DViewerCount === 0) {
      buttonText = 'Upgrade plan';
      description =
        'You do not have this item. Please upgrade your subscription plan or buy this item separately.';
      onButtonClick = () =>
        navigateToUpgradePlan({ browsePlan: true, newTab: true, referrer: window.location.href });
      buttonText2 = 'Buy item';
      onButtonClick2 = buy3DviewerAndAr;
    } else {
      return null;
    }

    openInfoDialog({
      title: title,
      description: description,
      buttonText: buttonText,
      onButtonClick: onButtonClick,
      buttonText2: buttonText2,
      onButtonClick2: onButtonClick2,
      addOrSeparator: false,
      btnContainerClass: 'align-items-center',
      closeable: false,
      designV2: true,
      designV2Props: {
        fillBtnClassName: styles.fillBtn,
        okBtnClassName: styles.btnLink,
      },
    });
  };

  return (
    <>
      <h4 style={{ fontSize: '1.375rem', lineHeight: '1.75rem' }}>AR Viewer</h4>
      <div
        className="d-flex gap-4 flex-row justify-content-between ar-viewer"
        style={{
          padding: '1.5rem 1rem',
          maxWidth: '28rem',
          backgroundColor: '#FBFAF9',
        }}>
        <div className="productDetails_qr_code_inner">
          <span className="fw-normal">View in your space</span>
          <span className="text-muted">
            Scan the QR code with your camera to experience the product in your own space.
          </span>
          {isGuestUser() || isGuestLogin ? null : (
            <ShareButton
              className="share_button"
              menuClassName="me-auto"
              onClick={
                isPublicPage && !currentUser
                  ? () => navigate(SIGN_IN_ROUTE) // SIGNUP_ROUTE // Commenting this code to prevent signup
                  : productInfo?.product_viewer_status || pdpArViewerCount
                    ? null
                    : (!activePlan && available3DViewerCount === 0) || available3DViewerCount === 0
                      ? isPackProduct
                        ? null
                        : handleShareForUse
                      : null
              }
              menu={actionMenu}
            />
          )}
          {/* <Button
          size={'lg'}
          loading={buyLoading}
          className="lf-btn-1"
          onClick={buy3DviewerAndAr}
          style={{ width: '6rem' }}>
          Buy <img src={CartIconWhite} style={{ width: '24px', margin: '0 0 0 0.5rem' }} />
        </Button> */}
        </div>
        <ARQRcode
          propId={propId}
          propName={propName}
          isPublicPage={isPublicPage}
          loading={loading}
          orgProductUniqueCodeId={orgProductUniqueCodeId}
          className={'productDetails_qr_code'}
        />
      </div>
    </>
  );
}

export default ARViewButton;
